export type ProviderCapability =
  | 'event_search' | 'listing_search' | 'listing_detail' | 'inventory'
  | 'orders' | 'sales' | 'transfers' | 'authentication' | 'refresh' | 'sync';

export type ProviderCapabilities = Readonly<Record<ProviderCapability, boolean>>;

export const noProviderCapabilities = (): ProviderCapabilities => ({
  event_search: false, listing_search: false, listing_detail: false, inventory: false,
  orders: false, sales: false, transfers: false, authentication: false, refresh: false, sync: false,
});
